import { FC } from 'react'
import { type Media } from 'content-types/UploadFile/UploadFile'
import { UploadFileMediaFragment } from 'generated/graphql'

import { UploadFileMediaServer } from './UploadFile.MediaServer'
import { UploadFileMediaView } from './UploadFile.MediaView'

// NOTE: Remove the duplication betwwen this and Media
export type UploadFileMediaContext = {
    embedSVG: boolean,
    loading?: 'lazy' | 'eager',
    showControls?: boolean,
    poster?: Media,
    alternativeText?: string | null
}
& Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height' | 'id'>
& {
    width?: number | null | undefined,
    height?: number | null | undefined
}

export const UploadFileMedia: FC<UploadFileMediaContext & {
    id: string | null,
    attributes?: UploadFileMediaFragment
}> = ({id,attributes,...media}) =>
      attributes !== undefined && attributes !== null ? <UploadFileMediaView {...attributes} {...media} />
    : id !== null ? <UploadFileMediaServer id={id} {...media} />
    : <></>
